import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/setting/_layout")({
    component: SettingLayout,
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.setting.title"),
        };
    },
});

function SettingLayout() {
    return <Outlet />;
}
